import { fetchGetJson } from '@/script/common';
import store from '@/plugin/store';

export default {
    setGlobalData: async () => {
        await fetchGetJson(`/Home/GetGlobalData`).then(resp => {
            store.commit('SetGlobalData', resp);
        });
    }
};